window.addEventListener('load', function() {
  const burger = document.querySelector('#burger'),
        header = document.querySelector('.header-global');
  burger.addEventListener('click', function() {
    header.classList.toggle('menu-opened');
    document.getElementById("kfg-modal").classList.remove("kfgm-open");
  });
});
